module.exports = __webpack_public_path__ + "media/images/touch/homescreen72-6466bb052654d60e3ff2516fe55a653b.png";